import React from 'react';
import { IconSend } from './ChatIcons';

export default function ChatInputForm({
  inputRef,
  value,
  onChange,
  onSubmit,
  onKeyDown,
  disabled,
  canSend
}) {
  return (
    <form className="chatbox-input-form" onSubmit={onSubmit}>
      <div className="chatbox-input-shell">
        <textarea
          ref={inputRef}
          className="chatbox-input"
          placeholder="Shkruani pyetjen tuaj…"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          disabled={disabled}
          rows={1}
          aria-label="Mesazhi"
        />
        <span className="chatbox-input-hint">Enter ↵</span>
      </div>
      <button
        type="submit"
        className={`chatbox-send-button${canSend ? ' chatbox-send-button--ready' : ''}`}
        disabled={!canSend}
        aria-label="Dërgo mesazhin"
      >
        <IconSend />
      </button>
    </form>
  );
}
